/*
 * Ajustes nos controles da direita do cabeçalho: o idioma vira a pílula com o código ("PT ⌄"), o "Entrar" ganha o ícone e o
 * seletor de tema sai do cabeçalho quando o rodapé da barra lateral já o
 * oferece.
 */
import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import { forumBool } from '../utils/settings';
import LocaleSwitcher from './LocaleSwitcher';
import { installBadgeTooltipPosition } from './HeaderCenter';
export default function extendHeader() {
  // As dicas dos badges do título no cabeçalho fixo abrem para baixo.
  installBadgeTooltipPosition();

  // O fof/drafts põe uma pena (DraftsDropdown, chave `Drafts`) no cabeçalho.
  // Esse ícone sai: os rascunhos ficam no "⌄" do botão "Novo
  // tópico". O initializer do fof roda depois do tema, então a remoção é
  // registrada no `mount`, quando todos os itens já foram acrescentados.
  override(app, 'mount', function (original, ...args) {
    extend(HeaderSecondary.prototype, 'items', function (items) {
      if (items.has('Drafts')) items.remove('Drafts');
    });
    return original(...args);
  });
  extend(HeaderSecondary.prototype, 'items', function (items) {
    const sidebarFooter = forumBool('canelaSidebarEnabled', true) && forumBool('canelaSidebarFooter', true);
    if (sidebarFooter && items.has('themeSwitcher')) {
      items.remove('themeSwitcher');
    }
    if (items.has('locale')) {
      // O seletor de idioma: o código do idioma atual numa pílula e, aberto,
      // os nomes dos idiomas num balão com seta.
      items.setContent('locale', LocaleSwitcher());

      // Para o visitante, o "PT" vem depois de Cadastrar-se/Entrar;
      // logado, ele vem antes dos ícones.
      if (!app.session.user) items.setPriority('locale', -10);
    }

    // "Entrar" leva o ícone de pessoa.
    if (items.has('logIn')) {
      const logIn = items.get('logIn');
      if (logIn && logIn.attrs) logIn.attrs.icon = 'far fa-user';
    }
  });
}
flarum.reg.add('ramon-canela', 'forum/shell/extendHeader', extendHeader);